export default __webpack_public_path__ + "a965a230299548a92900fc00d2d39dff.png";